import ReverificationOverviewDev from './ReverificationOverviewDev';
import CollegeOverviewDev from './CollegeOverviewDev';
import VendorOverView from './VendorOverView';

export default function ReverificationDashboardDev() {


    return (
        <>
            <ReverificationOverviewDev />
            <CollegeOverviewDev />

            {/* Vendor Reverification Stats */}
            <VendorOverView />
        </>
    )
}